import { route } from "../../../routes";
import { useNavigate } from "react-router-dom";
import { BreadcrumbNavigation } from "../../BreadcrumbNavigation";

export const BondDetailBreadcrumbs = ({ issuerName }: { issuerName: string }) => {
  const navigate = useNavigate();
  const breadcrumbItems = [
    {
      content: "GoodFill",
      onClick: () => {
        navigate(route.dashboard());
      },
    },
    {
      content: issuerName,
    },
  ];

  return <BreadcrumbNavigation items={breadcrumbItems} />;
};
